/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getConstrainRegion = _interopRequireDefault(require("../../../../common/getConstrainRegion"));
var _prepareAlignOffset = _interopRequireDefault(require("../utils/prepareAlignOffset"));
var _this = void 0;
var _default = function _default(props, subMenuRegion, targetAlignRegion, constrainTo, domNode) {
  var constrainRegion = _getConstrainRegion.default.call(_this, constrainTo, domNode);
  if (typeof props.alignSubMenu === 'function') {
    props.alignSubMenu(subMenuRegion, targetAlignRegion, constrainRegion);
  } else {
    var alignPositions = props.alignPositions;
    var offset = props.rtl ? props.rtlSubmenuAlignOffset : props.submenuAlignOffset;
    offset = (0, _prepareAlignOffset.default)(offset, alignPositions.length);
    var pos = subMenuRegion.alignTo(targetAlignRegion, alignPositions, {
      offset: offset,
      constrain: constrainRegion
    });
    return pos == 'tl-tr' || pos == 'tr-tl' ? 1 : -1;
  }
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Menu/src/align/index.js
// module id = 698
// module chunks = 0